import {
  AdminClaimPracticeAuthorizationRequest,
  AdminRevokePracticeAuthorizationRequest,
} from "@shared/zod/schemas/requests/admin"
import { PageRequest } from "@shared/zod/schemas/requests/page"
import { AdminPracticeAuthorizationClaimPageResponse } from "@shared/zod/schemas/responses/admin"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const findAll = async (query?: PageRequest): Promise<AdminPracticeAuthorizationClaimPageResponse> => {
  const resp = await axiosAuth({
    url: "/admin/practiceauthorizations",
    method: "get",
    params: query,
  })
  return resp.data
}

export const createClaim = async (req: AdminClaimPracticeAuthorizationRequest): Promise<void> => {
  await axiosAuth({
    url: "/admin/practiceauthorizations",
    method: "post",
    data: req,
  })
  return undefined
}

export const revokeClaim = async (req: AdminRevokePracticeAuthorizationRequest): Promise<void> => {
  await axiosAuth({
    url: "/admin/practiceauthorizations",
    method: "delete",
    data: req,
  })
  return undefined
}
